import {ActionReducerMap, MetaReducer} from '@ngrx/store';
import {environment} from 'src/environments/environment';
import * as fromServiceCategory from '../entities/system-settings/service-category/service-category.reducer';
import * as fromCurrencyType from '../entities/system-settings/currency-type/currency-type.reducer';
import * as fromInstitution from '../entities/system-settings/institution/institution.reducer';
import * as fromSector from '../entities/system-settings/sector/sector.reducer';
import * as fromMinistry from '../entities/system-settings/ministry/ministry.reducer';
import * as fromInstutionFunction from '../entities/instution-settings/instution-function/instution-function.reducer';
import * as fromApprovalFlow from '../entities/instution-settings/approval-flow/approval-flow.reducer';
import * as fromInstitutionAdmin
  from '../entities/system-settings/institution/institution-admin/institution-admin.reducer';
import * as fromService from '../entities/service-management/service/service.reducer';
import * as fromRole from '../entities/system-settings/role/role.reducer';
import * as fromPermission from '../entities/system-settings/permission/permission.reducer';
import * as fromServiceAutomationDetail
  from '../entities/service-management/service-automation-detail/service-automation-detail.reducer';
import * as fromApprovalFlowStages
  from '../entities/instution-settings/approval-flow-stages/approval-flow-stages.reducer';
import * as fromApprovalFlowSuccessor
  from '../entities/instution-settings/approval-flow-successor/approval-flow-successor.reducer';
import * as fromDesignation from '../entities/instution-settings/designation/designation.reducer';
import * as fromServiceRequirementGroup
  from '../entities/system-settings/service-requirement-group/service-requirement-group.reducer';
import * as fromServiceDeliveryDuration
  from '../entities/service-management/service-delivery-duration/service-delivery-duration.reducer';
import * as fromServiceChannel from '../entities/service-management/service-channel/service-channel.reducer';
import * as fromServiceManagementRequirement
  from '../entities/service-management/service-management-requirement/service-management-requirement.reducer';
import * as fromServiceRequirement from '../entities/system-settings/service-requirement/service-requirement.reducer';
import * as fromServiceBillingDetail
  from '../entities/service-management/service-billing-detail/service-billing-detail.reducer';
import * as fromServiceDirectCost from '../entities/service-management/service-direct-cost/service-direct-cost.reducer';
import * as fromServicePercentageScheme
  from '../entities/service-management/service-percentage-scheme/service-percentage-scheme.reducer';
import * as fromInstutionUser from '../entities/instution-settings/instution-user/instution-user.reducer';
import * as fromInstutionRole from '../entities/instution-settings/instution-role/instution-role.reducer';
import * as fromServiceFormulaScheme
  from '../entities/service-management/service-formula-scheme/service-formula-scheme.reducer';
import * as fromFormulaPayableScheme
  from '../entities/service-management/formula-payable-scheme/formula-payable-scheme.reducer';
import * as fromCatalogPayableScheme
  from '../entities/service-management/catalog-payable-scheme/catalog-payable-scheme.reducer';
import * as fromServiceCatalogScheme
  from '../entities/service-management/service-catalog-scheme/service-catalog-scheme.reducer';
import * as fromCitizensServices from '../entities/citizens/citizens-services/citizens-services.reducer';
import * as fromCitizensServicesCategory
  from '../entities/citizens/citizens-services-category/citizens-services-category.reducer';
import * as fromCitizensServicesGroups
  from '../entities/citizens/citizens-services-groups/citizens-services-groups.reducer';
import * as fromCitizensServicesRequirements
  from '../entities/citizens/citizens-services-requirements/citizens-services-requirements.reducer';
import * as fromCitizensServicesAutomationDetails
  from '../entities/citizens/citizens-services-automation-details/citizens-services-automation-details.reducer';
import * as fromCitizensServicesProvisionMeans
  from '../entities/citizens/citizens-services-provision-means/citizens-services-provision-means.reducer';
import * as fromCitizensServicesExistanceSource
  from '../entities/citizens/citizens-services-existance-source/citizens-services-existance-source.reducer';
import * as fromCitizensServicesDeliveryProcedureSteps
  from '../entities/citizens/citizens-services-delivery-procedure-steps/citizens-services-delivery-procedure-steps.reducer';
import * as fromCitizensServicesDeliveryProcedureDiagram
  from '../entities/citizens/citizens-services-delivery-procedure-diagram/citizens-services-delivery-procedure-diagram.reducer';
import * as fromCitizensServicesDeliveryChannel
  from '../entities/citizens/citizens-services-delivery-channel/citizens-services-delivery-channel.reducer';
import * as fromCitizensServicesResult
  from '../entities/citizens/citizens-services-result/citizens-services-result.reducer';
import * as fromSubService from '../entities/service-management/sub-service/sub-service.reducer';
import * as fromCitizensServicesSector
  from '../entities/citizens/citizens-services-sector/citizens-services-sector.reducer';
import * as fromCitizensGroupSummaries
  from '../entities/citizens/citizens-group-summaries/citizens-group-summaries.reducer';
import * as fromCitizensProvidersSummaries
  from '../entities/citizens/citizens-providers-summaries/citizens-providers-summaries.reducer';
import * as fromCitizensFreeServicesSummaries
  from '../entities/citizens/citizens-free-services-summaries/citizens-free-services-summaries.reducer';
import * as fromUploadableForm from '../entities/service-management/uploadable-form/uploadable-form.reducer';
import * as fromFillableForm from '../entities/service-management/fillable-form/fillable-form.reducer';
import * as fromFillableFormField from '../entities/service-management/fillable-form-field/fillable-form-field.reducer';
import * as fromSampleForm from '../entities/service-management/sample-form/sample-form.reducer';
import * as fromProcedureDiagram from '../entities/service-management/procedure-diagram/procedure-diagram.reducer';
import * as fromCitizenVerifyPhoneNumber
  from '../entities/citizens/register/citizen-verify-phone-number/citizen-verify-phone-number.reducer';
import * as fromCitizenVerifyOptNumber
  from '../entities/citizens/register/citizen-verify-opt-number/citizen-verify-opt-number.reducer';
import * as fromCreateUsers from '../entities/citizens/register/create-users/create-users.reducer';
import * as fromCitizenVerifyPassword
  from '../entities/citizens/register/citizen-verify-password/citizen-verify-password.reducer';
import * as fromUpdateCitizenPassword
  from '../entities/citizens/register/update-citizen-password/update-citizen-password.reducer';
import * as fromUploadableFormAttachment
  from '../entities/service-management/uploadable-form-attachment/uploadable-form-attachment.reducer';
import * as fromFeedbackCategory from '../entities/feedback-category/feedback-category.reducer';
import * as fromFeedback from '../entities/feedback/feedback.reducer';
import * as fromMediaImage from '../entities/media-image/media-image.reducer';
import * as fromServiceApprovalFlow
  from '../entities/service-management/service-approval-flow/service-approval-flow.reducer';
import * as fromFormResponse from '../entities/service-management/form-response/form-response.reducer';
import * as fromFormFieldOption from '../entities/service-management/form-field-option/form-field-option.reducer';
import * as fromApprovedService from '../entities/service-management/approved-service/approved-service.reducer';
import * as fromCitizenGetAllFeedbackCategories
  from '../entities/citizens/citizen-get-all-feedback-categories/citizen-get-all-feedback-categories.reducer';
import * as fromServiceChangeRequest
  from '../entities/service-management/service-change-request/service-change-request.reducer';
import * as fromCitizensFillableFormResponse
  from '../entities/citizens/citizens-fillable-form-response/citizens-fillable-form-response.reducer';
import * as fromServiceRequestedChange
  from '../entities/service-management/service-requested-change/service-requested-change.reducer';
import * as fromCitizensUploadableFormRequest
  from '../entities/citizens/citizens-uploadable-form-request/citizens-uploadable-form-request.reducer';
import * as fromServiceSocialGroup
  from '../entities/service-management/service-social-group/service-social-group.reducer';
import * as fromBranchOffice from '../entities/instution-settings/branch-office/branch-office.reducer';
import * as fromRegions from '../entities/locations/regions/regions.reducer';
import * as fromDistricts from '../entities/locations/districts/districts.reducer';
import * as fromWards from '../entities/locations/wards/wards.reducer';
import * as fromStreets from '../entities/locations/streets/streets.reducer';
import * as fromStoreItem from '../entities/store-item/store-item.reducer';
import * as fromServiceBranchOffice
  from '../entities/service-management/service-branch-office/service-branch-office.reducer';
import * as fromCollaborationReason
  from '../entities/system-settings/collaboration-reason/collaboration-reason.reducer';
import * as fromServiceCollaboration
  from '../entities/service-management/service-collaboration/service-collaboration.reducer';
import * as fromInstitutionServicesSummary
  from '../entities/service-management/institution-services-summary/institution-services-summary.reducer';
import * as fromActivateAccount from '../entities/uaa-setting/activate-account/activate-account.reducer';
import * as fromServiceChangeRequestReview
  from '../entities/service-management/service-change-request-review/service-change-request-review.reducer';
import * as fromUserManagement from '../entities/system-settings/user-management/user-management.reducer';
import * as fromSystemNames from '../entities/instution-settings/system-names/system-names.reducer';
import * as fromMyRequestedServices from '../entities/citizens/my-requested-services/my-requested-services.reducer';
import * as fromFormFixedResponse from '../entities/service-management/form-fixed-response/form-fixed-response.reducer';
import * as fromCitizens from '../entities/citizens/register/citizens/citizens.reducer';
import * as fromFrequentlyAskedQuestion from '../entities/frequently-asked-question/frequently-asked-question.reducer';
import * as fromTranslations from '../entities/system-settings/translation/translation.reducer';
import * as fromServiceRegSummary from '../entities/service-management/ministry-sector-services-summary/ministry-sector-services-summary.reducer';

export interface AppState {
  [fromServiceCategory.serviceCategoriesFeatureKey]: fromServiceCategory.State;
  [fromCurrencyType.currencyTypeFeatureKey]: fromCurrencyType.State;
  [fromInstitution.institutionsFeatureKey]: fromInstitution.State;
  [fromSector.sectorsFeatureKey]: fromSector.State;
  [fromMinistry.ministriesFeatureKey]: fromMinistry.State;
  [fromInstutionFunction.instutionFunctionsFeatureKey]: fromInstutionFunction.State;
  [fromApprovalFlow.approvalFlowsFeatureKey]: fromApprovalFlow.State;
  [fromInstitutionAdmin.institutionAdminsFeatureKey]: fromInstitutionAdmin.State;
  [fromRole.rolesFeatureKey]: fromRole.State;
  [fromPermission.permissionsFeatureKey]: fromPermission.State;
  [fromService.servicesFeatureKey]: fromService.State;
  [fromApprovalFlowStages.approvalFlowStagesesFeatureKey]: fromApprovalFlowStages.State;
  [fromApprovalFlowSuccessor.approvalFlowSuccessorsFeatureKey]: fromApprovalFlowSuccessor.State;
  [fromDesignation.designationsFeatureKey]: fromDesignation.State;
  [fromServiceAutomationDetail.serviceAutomationDetailsFeatureKey]: fromServiceAutomationDetail.State;
  [fromServiceRequirementGroup.serviceRequirementGroupsFeatureKey]: fromServiceRequirementGroup.State;
  [fromServiceDeliveryDuration.serviceDeliveryDurationsFeatureKey]: fromServiceDeliveryDuration.State;
  [fromServiceChannel.serviceChannelsFeatureKey]: fromServiceChannel.State;
  [fromServiceManagementRequirement.serviceManagementRequirementsFeatureKey]: fromServiceManagementRequirement.State;
  [fromServiceRequirement.serviceRequirementsFeatureKey]: fromServiceRequirement.State;
  [fromServiceBillingDetail.serviceBillingDetailsFeatureKey]: fromServiceBillingDetail.State;
  [fromServiceDirectCost.serviceDirectCostsFeatureKey]: fromServiceDirectCost.State;
  [fromServicePercentageScheme.servicePercentageSchemesFeatureKey]: fromServicePercentageScheme.State;
  [fromInstutionUser.instutionUsersFeatureKey]: fromInstutionUser.State;
  [fromInstutionRole.instutionRolesFeatureKey]: fromInstutionRole.State;
  [fromServiceFormulaScheme.serviceFormulaSchemesFeatureKey]: fromServiceFormulaScheme.State;
  [fromFormulaPayableScheme.formulaPayableSchemesFeatureKey]: fromFormulaPayableScheme.State;
  [fromCatalogPayableScheme.catalogPayableSchemesFeatureKey]: fromCatalogPayableScheme.State;
  [fromServiceCatalogScheme.serviceCatalogSchemesFeatureKey]: fromServiceCatalogScheme.State;
  [fromCitizensServices.citizensServicesesFeatureKey]: fromCitizensServices.State;
  [fromCitizensServicesCategory.citizensServicesCategoriesFeatureKey]: fromCitizensServicesCategory.State;
  [fromCitizensServicesGroups.citizensServicesGroupsesFeatureKey]: fromCitizensServicesGroups.State;
  [fromCitizensServicesRequirements.citizensServicesRequirementsesFeatureKey]: fromCitizensServicesRequirements.State;
  [fromCitizensServicesAutomationDetails.citizensServicesAutomationDetailsesFeatureKey]: fromCitizensServicesAutomationDetails.State;
  [fromCitizensServicesProvisionMeans.citizensServicesProvisionMeansesFeatureKey]: fromCitizensServicesProvisionMeans.State;
  [fromCitizensServicesExistanceSource.citizensServicesExistanceSourcesFeatureKey]: fromCitizensServicesExistanceSource.State;
  [fromCitizensServicesDeliveryProcedureSteps.citizensServicesDeliveryProcedureStepsesFeatureKey]: fromCitizensServicesDeliveryProcedureSteps.State;
  [fromCitizensServicesDeliveryProcedureDiagram.citizensServicesDeliveryProcedureDiagramsFeatureKey]: fromCitizensServicesDeliveryProcedureDiagram.State;
  [fromCitizensServicesDeliveryChannel.citizensServicesDeliveryChannelsFeatureKey]: fromCitizensServicesDeliveryChannel.State;
  [fromCitizensServicesResult.citizensServicesResultsFeatureKey]: fromCitizensServicesResult.State;
  [fromCitizensServicesSector.citizensServicesSectorsFeatureKey]: fromCitizensServicesSector.State;
  [fromCitizensGroupSummaries.citizensGroupSummariesesFeatureKey]: fromCitizensGroupSummaries.State;
  [fromCitizensProvidersSummaries.citizensProvidersSummariesesFeatureKey]: fromCitizensProvidersSummaries.State;
  [fromCitizensFreeServicesSummaries.citizensFreeServicesSummariesesFeatureKey]: fromCitizensFreeServicesSummaries.State;
  [fromUploadableForm.uploadableFormsFeatureKey]: fromUploadableForm.State;
  [fromSubService.subServicesFeatureKey]: fromSubService.State;
  [fromFillableForm.fillableFormsFeatureKey]: fromFillableForm.State;
  [fromFillableFormField.fillableFormFieldsFeatureKey]: fromFillableFormField.State;
  [fromProcedureDiagram.procedureDiagramsFeatureKey]: fromProcedureDiagram.State;
  [fromCitizenVerifyPhoneNumber.citizenVerifyPhoneNumbersFeatureKey]: fromCitizenVerifyPhoneNumber.State;
  [fromCitizenVerifyPhoneNumber.citizenVerifyPhoneNumbersFeatureKey]: fromCitizenVerifyPhoneNumber.State;
  [fromCitizenVerifyOptNumber.citizenVerifyOptNumbersFeatureKey]: fromCitizenVerifyOptNumber.State;
  [fromCreateUsers.createUsersesFeatureKey]: fromCreateUsers.State;
  [fromCitizenVerifyPassword.citizenVerifyPasswordsFeatureKey]: fromCitizenVerifyPassword.State;
  [fromUpdateCitizenPassword.updateCitizenPasswordsFeatureKey]: fromUpdateCitizenPassword.State;
  [fromSampleForm.sampleFormsFeatureKey]: fromSampleForm.State;
  [fromUploadableFormAttachment.uploadableFormAttachmentsFeatureKey]: fromUploadableFormAttachment.State;
  [fromFeedbackCategory.feedbackCategoriesFeatureKey]: fromFeedbackCategory.State;
  [fromFeedback.feedbacksFeatureKey]: fromFeedback.State;
  [fromMediaImage.mediaImagesFeatureKey]: fromMediaImage.State;
  [fromServiceApprovalFlow.serviceApprovalFlowsFeatureKey]: fromServiceApprovalFlow.State;
  [fromFormResponse.formResponsesFeatureKey]: fromFormResponse.State;
  [fromFormFieldOption.formFieldOptionsFeatureKey]: fromFormFieldOption.State;
  [fromFormFieldOption.formFieldOptionsFeatureKey]: fromFormFieldOption.State;
  [fromFormFieldOption.formFieldOptionsFeatureKey]: fromFormFieldOption.State;
  [fromApprovedService.approvedServicesFeatureKey]: fromApprovedService.State;
  [fromCitizenGetAllFeedbackCategories.citizenGetAllFeedbackCategoriesesFeatureKey]: fromCitizenGetAllFeedbackCategories.State;
  [fromServiceChangeRequest.serviceChangeRequestsFeatureKey]: fromServiceChangeRequest.State;
  [fromCitizensFillableFormResponse.citizensFillableFormResponsesFeatureKey]: fromCitizensFillableFormResponse.State;
  [fromServiceRequestedChange.serviceRequestedChangesFeatureKey]: fromServiceRequestedChange.State;
  [fromCitizensUploadableFormRequest.citizensUploadableFormRequestsFeatureKey]: fromCitizensUploadableFormRequest.State;
  [fromServiceSocialGroup.serviceSocialGroupsFeatureKey]: fromServiceSocialGroup.State;
  [fromBranchOffice.branchOfficesFeatureKey]: fromBranchOffice.State;
  [fromRegions.regionsesFeatureKey]: fromRegions.State;
  [fromDistricts.districtsesFeatureKey]: fromDistricts.State;
  [fromWards.wardsesFeatureKey]: fromWards.State;
  [fromStreets.streetsesFeatureKey]: fromStreets.State;
  [fromServiceBranchOffice.serviceBranchOfficesFeatureKey]: fromServiceBranchOffice.State;
  [fromCollaborationReason.collaborationReasonsFeatureKey]: fromCollaborationReason.State;
  [fromServiceCollaboration.serviceCollaborationsFeatureKey]: fromServiceCollaboration.State;
  [fromInstitutionServicesSummary.institutionServicesSummariesFeatureKey]: fromInstitutionServicesSummary.State;
  [fromActivateAccount.activateAccountsFeatureKey]: fromActivateAccount.State;
  [fromActivateAccount.activateAccountsFeatureKey]: fromActivateAccount.State;
  [fromStoreItem.storeItemsFeatureKey]: fromStoreItem.State;
  [fromServiceChangeRequestReview.serviceChangeRequestReviewsFeatureKey]: fromServiceChangeRequestReview.State;
  [fromUserManagement.userManagementsFeatureKey]: fromUserManagement.State;
  [fromSystemNames.systemNamesesFeatureKey]: fromSystemNames.State;
  [fromMyRequestedServices.myRequestedServicesesFeatureKey]: fromMyRequestedServices.State;
  [fromFormFixedResponse.formFixedResponsesFeatureKey]: fromFormFixedResponse.State;
  [fromCitizens.citizensesFeatureKey]: fromCitizens.State;
  [fromFrequentlyAskedQuestion.frequentlyAskedQuestionsFeatureKey]: fromFrequentlyAskedQuestion.State;
  [fromTranslations.translationsFeatureKey]: fromTranslations.State;
  [fromServiceRegSummary.ministrySectorServicesSummaryFeatureKey]: fromServiceRegSummary.State;
}

export const reducers: ActionReducerMap<AppState> = {
  [fromServiceCategory.serviceCategoriesFeatureKey]:
  fromServiceCategory.reducer,
  [fromCurrencyType.currencyTypeFeatureKey]: fromCurrencyType.reducer,
  [fromInstitution.institutionsFeatureKey]: fromInstitution.reducer,
  [fromSector.sectorsFeatureKey]: fromSector.reducer,
  [fromMinistry.ministriesFeatureKey]: fromMinistry.reducer,
  [fromInstutionFunction.instutionFunctionsFeatureKey]:
  fromInstutionFunction.reducer,
  [fromApprovalFlow.approvalFlowsFeatureKey]: fromApprovalFlow.reducer,
  [fromInstitutionAdmin.institutionAdminsFeatureKey]:
  fromInstitutionAdmin.reducer,
  [fromService.servicesFeatureKey]: fromService.reducer,
  [fromRole.rolesFeatureKey]: fromRole.reducer,
  [fromPermission.permissionsFeatureKey]: fromPermission.reducer,
  [fromServiceAutomationDetail.serviceAutomationDetailsFeatureKey]:
  fromServiceAutomationDetail.reducer,
  [fromApprovalFlowStages.approvalFlowStagesesFeatureKey]:
  fromApprovalFlowStages.reducer,
  [fromApprovalFlowSuccessor.approvalFlowSuccessorsFeatureKey]:
  fromApprovalFlowSuccessor.reducer,
  [fromDesignation.designationsFeatureKey]: fromDesignation.reducer,
  [fromServiceRequirementGroup.serviceRequirementGroupsFeatureKey]:
  fromServiceRequirementGroup.reducer,
  [fromServiceDeliveryDuration.serviceDeliveryDurationsFeatureKey]:
  fromServiceDeliveryDuration.reducer,
  [fromServiceChannel.serviceChannelsFeatureKey]: fromServiceChannel.reducer,
  [fromServiceManagementRequirement.serviceManagementRequirementsFeatureKey]:
  fromServiceManagementRequirement.reducer,
  [fromServiceRequirement.serviceRequirementsFeatureKey]:
  fromServiceRequirement.reducer,
  [fromServiceBillingDetail.serviceBillingDetailsFeatureKey]:
  fromServiceBillingDetail.reducer,
  [fromServiceDirectCost.serviceDirectCostsFeatureKey]:
  fromServiceDirectCost.reducer,
  [fromServicePercentageScheme.servicePercentageSchemesFeatureKey]:
  fromServicePercentageScheme.reducer,
  [fromInstutionUser.instutionUsersFeatureKey]: fromInstutionUser.reducer,
  [fromInstutionRole.instutionRolesFeatureKey]: fromInstutionRole.reducer,
  [fromServiceFormulaScheme.serviceFormulaSchemesFeatureKey]:
  fromServiceFormulaScheme.reducer,
  [fromFormulaPayableScheme.formulaPayableSchemesFeatureKey]:
  fromFormulaPayableScheme.reducer,
  [fromCatalogPayableScheme.catalogPayableSchemesFeatureKey]:
  fromCatalogPayableScheme.reducer,
  [fromServiceCatalogScheme.serviceCatalogSchemesFeatureKey]:
  fromServiceCatalogScheme.reducer,
  [fromCitizensServices.citizensServicesesFeatureKey]:
  fromCitizensServices.reducer,
  [fromCitizensServicesCategory.citizensServicesCategoriesFeatureKey]:
  fromCitizensServicesCategory.reducer,
  [fromCitizensServicesGroups.citizensServicesGroupsesFeatureKey]:
  fromCitizensServicesGroups.reducer,
  [fromCitizensServicesRequirements.citizensServicesRequirementsesFeatureKey]:
  fromCitizensServicesRequirements.reducer,
  [fromCitizensServicesAutomationDetails.citizensServicesAutomationDetailsesFeatureKey]:
  fromCitizensServicesAutomationDetails.reducer,
  [fromCitizensServicesProvisionMeans.citizensServicesProvisionMeansesFeatureKey]:
  fromCitizensServicesProvisionMeans.reducer,
  [fromCitizensServicesExistanceSource.citizensServicesExistanceSourcesFeatureKey]:
  fromCitizensServicesExistanceSource.reducer,
  [fromCitizensServicesDeliveryProcedureSteps.citizensServicesDeliveryProcedureStepsesFeatureKey]:
  fromCitizensServicesDeliveryProcedureSteps.reducer,
  [fromCitizensServicesDeliveryProcedureDiagram.citizensServicesDeliveryProcedureDiagramsFeatureKey]:
  fromCitizensServicesDeliveryProcedureDiagram.reducer,
  [fromCitizensServicesDeliveryChannel.citizensServicesDeliveryChannelsFeatureKey]:
  fromCitizensServicesDeliveryChannel.reducer,
  [fromCitizensServicesResult.citizensServicesResultsFeatureKey]:
  fromCitizensServicesResult.reducer,
  [fromSubService.subServicesFeatureKey]: fromSubService.reducer,
  [fromCitizensServicesSector.citizensServicesSectorsFeatureKey]:
  fromCitizensServicesSector.reducer,
  [fromCitizensGroupSummaries.citizensGroupSummariesesFeatureKey]:
  fromCitizensGroupSummaries.reducer,
  [fromCitizensProvidersSummaries.citizensProvidersSummariesesFeatureKey]:
  fromCitizensProvidersSummaries.reducer,
  [fromCitizensFreeServicesSummaries.citizensFreeServicesSummariesesFeatureKey]:
  fromCitizensFreeServicesSummaries.reducer,
  [fromUploadableForm.uploadableFormsFeatureKey]: fromUploadableForm.reducer,
  [fromFillableForm.fillableFormsFeatureKey]: fromFillableForm.reducer,
  [fromFillableFormField.fillableFormFieldsFeatureKey]:
  fromFillableFormField.reducer,
  [fromProcedureDiagram.procedureDiagramsFeatureKey]:
  fromProcedureDiagram.reducer,
  [fromCitizenVerifyPhoneNumber.citizenVerifyPhoneNumbersFeatureKey]:
  fromCitizenVerifyPhoneNumber.reducer,
  [fromCitizenVerifyOptNumber.citizenVerifyOptNumbersFeatureKey]:
  fromCitizenVerifyOptNumber.reducer,
  [fromCreateUsers.createUsersesFeatureKey]: fromCreateUsers.reducer,
  [fromCitizenVerifyPassword.citizenVerifyPasswordsFeatureKey]:
  fromCitizenVerifyPassword.reducer,
  [fromUpdateCitizenPassword.updateCitizenPasswordsFeatureKey]:
  fromUpdateCitizenPassword.reducer,
  [fromSampleForm.sampleFormsFeatureKey]: fromSampleForm.reducer,
  [fromUploadableFormAttachment.uploadableFormAttachmentsFeatureKey]:
  fromUploadableFormAttachment.reducer,
  [fromFeedbackCategory.feedbackCategoriesFeatureKey]:
  fromFeedbackCategory.reducer,
  [fromFeedback.feedbacksFeatureKey]: fromFeedback.reducer,
  [fromMediaImage.mediaImagesFeatureKey]: fromMediaImage.reducer,
  [fromServiceApprovalFlow.serviceApprovalFlowsFeatureKey]:
  fromServiceApprovalFlow.reducer,
  [fromFormResponse.formResponsesFeatureKey]: fromFormResponse.reducer,
  [fromFormFieldOption.formFieldOptionsFeatureKey]: fromFormFieldOption.reducer,
  [fromApprovedService.approvedServicesFeatureKey]: fromApprovedService.reducer,
  [fromCitizenGetAllFeedbackCategories.citizenGetAllFeedbackCategoriesesFeatureKey]:
  fromCitizenGetAllFeedbackCategories.reducer,
  [fromServiceChangeRequest.serviceChangeRequestsFeatureKey]:
  fromServiceChangeRequest.reducer,
  [fromCitizensFillableFormResponse.citizensFillableFormResponsesFeatureKey]:
  fromCitizensFillableFormResponse.reducer,
  [fromServiceRequestedChange.serviceRequestedChangesFeatureKey]:
  fromServiceRequestedChange.reducer,
  [fromCitizensUploadableFormRequest.citizensUploadableFormRequestsFeatureKey]:
  fromCitizensUploadableFormRequest.reducer,
  [fromServiceSocialGroup.serviceSocialGroupsFeatureKey]:
  fromServiceSocialGroup.reducer,
  [fromBranchOffice.branchOfficesFeatureKey]: fromBranchOffice.reducer,
  [fromRegions.regionsesFeatureKey]: fromRegions.reducer,
  [fromDistricts.districtsesFeatureKey]: fromDistricts.reducer,
  [fromWards.wardsesFeatureKey]: fromWards.reducer,
  [fromStreets.streetsesFeatureKey]: fromStreets.reducer,
  [fromServiceBranchOffice.serviceBranchOfficesFeatureKey]:
  fromServiceBranchOffice.reducer,
  [fromCollaborationReason.collaborationReasonsFeatureKey]:
  fromCollaborationReason.reducer,
  [fromServiceCollaboration.serviceCollaborationsFeatureKey]:
  fromServiceCollaboration.reducer,
  [fromInstitutionServicesSummary.institutionServicesSummariesFeatureKey]:
  fromInstitutionServicesSummary.reducer,
  [fromStoreItem.storeItemsFeatureKey]: fromStoreItem.reducer,
  [fromActivateAccount.activateAccountsFeatureKey]: fromActivateAccount.reducer,
  [fromServiceChangeRequestReview.serviceChangeRequestReviewsFeatureKey]: fromServiceChangeRequestReview.reducer,
  [fromUserManagement.userManagementsFeatureKey]: fromUserManagement.reducer,
  [fromSystemNames.systemNamesesFeatureKey]: fromSystemNames.reducer,
  [fromMyRequestedServices.myRequestedServicesesFeatureKey]: fromMyRequestedServices.reducer,
  [fromFormFixedResponse.formFixedResponsesFeatureKey]: fromFormFixedResponse.reducer,
  [fromCitizens.citizensesFeatureKey]: fromCitizens.reducer,
  [fromFrequentlyAskedQuestion.frequentlyAskedQuestionsFeatureKey]: fromFrequentlyAskedQuestion.reducer,
  [fromTranslations.translationsFeatureKey]: fromTranslations.reducer,
  [fromServiceRegSummary.ministrySectorServicesSummaryFeatureKey]: fromServiceRegSummary.reducer,

};

export const metaReducers: MetaReducer<AppState>[] = !environment.production
  ? []
  : [];

